import React, { Component } from "react";
import "./news.css";
import { Link } from "react-router-dom";

class newsElement extends Component {

    render() {
        return (
            <React.Fragment key={this.props.Key}>
                <div className="news-item">
                    
                        <figure className="figure">
                            <img src={`${this.props.imageUrl}`} className="figure-img img-fluid " alt="..." />
                            <figcaption className="figure-caption">
                                {this.props.title}
                                <span className="time">{this.props.relaseDate}</span>
                                <p>
                                    {this.props.firstParagraph}
                                </p>
                            </figcaption>
                        </figure>
                   
                </div>
            </React.Fragment >
        );
    }
}

export default newsElement;